// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1747":"a77e737521c9fae0","2132":"b6b92fef56ee6275","3189":"5ffba66b48142115","4276":"78e37040d21f3fa8","4888":"24d53db1268f09af"}[chunkId] + ".css";
};